export default "__VITE_ASSET__a6697bda__"